import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Erreur — octogone "stop" avec croix.
 * Style PayFit : forme octogonale (stop sign) plus expressive qu'un simple cercle,
 * croix en lieu d'un point d'exclamation pour distinguer clairement de WarningIcon.
 */
export const ErrorIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Octogone rouge */}
      <path
        d="M8 3h8l5 5v8l-5 5H8l-5-5V8l5-5z"
        fill="hsl(var(--destructive))" fillOpacity="0.9"
      />
      {/* Contour primary */}
      <path
        d="M8 3h8l5 5v8l-5 5H8l-5-5V8l5-5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Croix */}
      <path
        d="M9 9l6 6M15 9l-6 6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round"
      />
    </svg>
  ),
);
ErrorIcon.displayName = "ErrorIcon";
